

<template>
    <div> 
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>  
        
        <div class="d-flex flex-column PayImgContainer mx-auto">
            <img 
                class="PayImg mx-auto"
                src="../../assets/images/FinishNoWord.jpg"
                width="300"
            />
            <span class="payWord WhiteWord">付款成功！</span>
        </div>

        <div class="d-flex flex-column PaymentForm" >
            <div class="PaymentTitle">
                <div class="">交易內容：</div>
            </div>
            
            <div class="PaymentSubForm"> 
                <div class="d-flex align-items-center my-2">
                    <span class=" mx-2">訂單編號：</span>
                    <span>{{OrderData.payOrderId}}</span>
                </div>
                <div class="d-flex align-items-top my-2">
                    <span class="mx-2">課程名稱：</span>
                    <div class="d-flex flex-column">
                        <span v-for="course in OrderData.courseName">{{course}}</span>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

// import liff from '@line/liff';

export default {
    name: 'PaySuccess',
    components:{Nav},
    data () {
        return {
            showLoading:'',
            OrderData:{}
        }
    },
    mounted(){
        

    },
    methods:{
        
    },
    created(){
        this.OrderData = JSON.parse(sessionStorage.getItem('OrderData'));
        // this.OrderData = this.$route.params.OrderData;
        // this.OrderData = {
        //     payId:2630,
        //     payWay:51,
        //     payOrderId:'46905H0016R44562',
        //     payMoney:'TWD $5000',
        //     payEndDate:'2023-04-01 10:00',
        //     payType:'訂金',
        //     courseName:'Regular ESL 1週',
        // }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pay/PaySuccess.vue